import * as fromDatatype from '../datatype-library/index';

export interface bl_crm_contact_key_target_link_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  key_guid: fromDatatype.GuidDataFieldInterface;
  contact_hdr_guid: fromDatatype.GuidDataFieldInterface;
  target_hdr_table: fromDatatype.VarcharDatatypeInterface;
  target_hdr_guid: fromDatatype.GuidDataFieldInterface;
  target_line_table: fromDatatype.VarcharDatatypeInterface;
  target_line_guid: fromDatatype.GuidDataFieldInterface;
  probability: fromDatatype.NumericDatatypeInterface;
  link_type: fromDatatype.VarcharDatatypeInterface;
  module_guid: fromDatatype.VarcharDatatypeInterface;
  applet_guid: fromDatatype.VarcharDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  updated_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}

export class bl_crm_contact_key_target_link_RowClass
  implements bl_crm_contact_key_target_link_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    key_guid: fromDatatype.GuidDataFieldInterface;
    contact_hdr_guid: fromDatatype.GuidDataFieldInterface;
    target_hdr_table: fromDatatype.VarcharDatatypeInterface;
    target_hdr_guid: fromDatatype.GuidDataFieldInterface;
    target_line_table: fromDatatype.VarcharDatatypeInterface;
    target_line_guid: fromDatatype.GuidDataFieldInterface;
    probability: fromDatatype.NumericDatatypeInterface;
    link_type: fromDatatype.VarcharDatatypeInterface;
    module_guid: fromDatatype.VarcharDatatypeInterface;
    applet_guid: fromDatatype.VarcharDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
    updated_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
}